import { buildUrl, erase, get, patch, post, put } from "../utils/axiosRequests";
import {
  DEFAULT_HTTP_TIMEOUT,
  GENOME_API_CATEGORIES,
  GENOME_API_DISEASE_DETAIL,
  GENOME_API_DISEASES,
  GENOME_API_PATIENT_BACKGROUNDS,
  GENOME_API_DOWNLOAD_MANUAL,
  GENOME_API_PATIENT_RECORD,
  GENOME_API_RECORD,
  GENOME_API_RECORD_BACKGROUNDS,
  GENOME_API_RECORD_DISEASE,
  GENOME_API_RECORD_DISEASES,
  GENOME_API_RECORD_SYMPTOMS,
  GENOME_API_SYMPTOMS,
  GENOME_API_RECORD_PATIENT_BACKGROUNDS,
} from "../utils/constants";

export const getCategories = (callback, catchCallback) => {
  get(GENOME_API_CATEGORIES, { timeout: DEFAULT_HTTP_TIMEOUT }, false, callback, catchCallback);
};

export const getSymptoms = (keywords, categories, limit, offset, callback) => {
  let url = GENOME_API_SYMPTOMS;

  if (!!categories?.length) {
    url = `${url}?category_ids=${categories}`;

    if (!!keywords) {
      url = `${url}&keywords=${keywords}`;
    }
  } else if (!!keywords) {
    url = `${url}?keywords=${keywords}`;
  }

  url = `${url}&limit=${limit}&offset=${offset}`;
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, false, callback);
};

export const getDiseases = (keywords, symptoms, recordId, limit, offset, callback) => {
  let url = GENOME_API_DISEASES;

  if (!!keywords) {
    url = `${url}?keywords=${keywords}`;
  }

  if (!!symptoms) {
    let symptomsString = "symptoms=";

    let symptomsIds = [];

    symptoms.forEach((symptom) => {
      symptomsIds = [...symptomsIds, symptom];
    });

    if (symptomsIds.length > 0) symptomsString += symptomsIds;

    url = `${GENOME_API_DISEASES}?${symptomsString}`;
  }

  if (recordId) {
    url = `${url}&record_id=${recordId}`;
  }

  url = `${url}&limit=${limit}&offset=${offset}`;
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, false, callback);
};

export const getDiseaseDetail = (disease_id, callback) => {
  const url = buildUrl(GENOME_API_DISEASE_DETAIL, { disease_id });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, false, callback);
};

export const getRecordsService = (limit, offset, callback) => {
  const url = `${GENOME_API_RECORD}?skip=${offset}&limit=${limit}`;
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getPatientService = (patient_id, callback) => {
  const url = `${GENOME_API_RECORD}?patient_id=${patient_id}`;
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, false, callback);
};

export const postCreateRecordService = (body, callback, catchCallback) => {
  post(GENOME_API_RECORD, body, {}, true, callback, catchCallback);
};

export const patchUpdateRecordService = (record_id, body, callback) => {
  const url = buildUrl(GENOME_API_PATIENT_RECORD, { record_id });
  patch(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const deleteRecordService = (record_id, callback) => {
  const url = buildUrl(GENOME_API_PATIENT_RECORD, { record_id });
  erase(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const deletePatientSymptomsService = (record_id, symptoms, callback) => {
  const queryString = "symptom_ids=";
  let url = buildUrl(GENOME_API_RECORD_SYMPTOMS, { record_id }) + "?";

  for (const symptom of symptoms) {
    url = `${url}${queryString}${symptom}&`;
  }

  erase(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const putUpdatePatientSymptomsService = (record_id, body, callback) => {
  const url = buildUrl(GENOME_API_RECORD_SYMPTOMS, { record_id });
  put(url, body, {}, true, callback);
};

export const putUpdateFamilyBackgroundsService = (record_id, body, callback) => {
  const url = buildUrl(GENOME_API_RECORD_BACKGROUNDS, { record_id });
  put(url, body, {}, true, callback);
};

export const putUpdatePatientBackgroundsService = (record_id, body, callback) => {
  const url = buildUrl(GENOME_API_RECORD_PATIENT_BACKGROUNDS, { record_id });
  put(url, body, {}, true, callback);
};

export const deleteFamilyBackgroundsService = (record_id, backgrounds, callback) => {
  const queryString = "background_ids=";
  let url = buildUrl(GENOME_API_RECORD_BACKGROUNDS, { record_id }) + "?";

  for (const background of backgrounds) {
    url = `${url}${queryString}${background}&`;
  }

  erase(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const deletePatientBackgroundsService = (record_id, backgrounds, callback) => {
  const queryString = "background_ids=";
  let url = buildUrl(GENOME_API_RECORD_PATIENT_BACKGROUNDS, { record_id }) + "?";

  for (const background of backgrounds) {
    url = `${url}${queryString}${background}&`;
  }

  erase(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getPatientSymptomsService = (record_id, callback) => {
  const url = buildUrl(GENOME_API_RECORD_SYMPTOMS, { record_id });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getPatientFamilyBackgroundsService = (record_id, callback) => {
  const url = buildUrl(GENOME_API_RECORD_BACKGROUNDS, { record_id });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getPatientDiseasesService = (record_id, callback) => {
  const url = buildUrl(GENOME_API_RECORD_DISEASES, { record_id });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const getPatientBackgroundsService = (record_id, callback) => {
  const url = buildUrl(GENOME_API_PATIENT_BACKGROUNDS, { record_id });
  get(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const putUpdatePatientDiseasesService = (record_id, body, callback) => {
  const url = buildUrl(GENOME_API_RECORD_DISEASES, { record_id });
  put(url, body, {}, true, callback);
};

export const deletePatientDiseasesService = (record_id, diseases, callback) => {
  const queryString = "diseases_ids=";
  let url = buildUrl(GENOME_API_RECORD_DISEASES, { record_id }) + "?";

  for (const disease of diseases) {
    url = `${url}${queryString}${disease}&`;
  }

  erase(url, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};

export const patchIsDiagnoseService = (record_id, disease_id, body, callback, errorCallback) => {
  const url = buildUrl(GENOME_API_RECORD_DISEASE, { record_id, disease_id });
  patch(url, body, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback, errorCallback);
};

export const downloadManualService = (callback) => {
  get(GENOME_API_DOWNLOAD_MANUAL, { timeout: DEFAULT_HTTP_TIMEOUT }, true, callback);
};
